import type { FaireProductEntity } from "../../entity_types/product";

export const p_46j2hrr5ya: FaireProductEntity = {
  token: "p_46j2hrr5ya",
  type: "product",
  name: "puppy dog mini enclosure notecard",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/1d5abe1af88cb0cc5e4fe5ef4ab990bd8bb72b8c1cb4eff304374a6f584f39d2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b47d92f9a9fb073cac7c83d261832cdd0af4555fd367805a821e7280728eaa82.jpeg",
    "https://cdn.faire.com/fastly/9dec1c7fde064c0de84fdc549961fcefbf36c937aaad904d9704db911d0d61d0.jpeg",
    "https://cdn.faire.com/fastly/80029d8e40de659340fc375ccfe1ecda44c5d04be7807ba76827f112cadc3e87.jpeg",
    "https://cdn.faire.com/fastly/c4e037c54ef32cad11b06a7fc1afd3e07929e38e3dfecd4f79ba1f401945a123.jpeg",
    "https://cdn.faire.com/fastly/49cb22efc7ba1cc6e016f40002ebc2168af2d9130e6559f56295f9f2e2e13a06.jpeg",
    "https://cdn.faire.com/fastly/77cde735bec62ab375f111ef525b13a7368c3631cba4ed1fc74d5ec1ea609b11.jpeg",
  ],
  priceDollars: 2,
  description:
    'A mini notecard for petite greetings. Perfect for adding to a gift or popping in a gift card for a pretty presentation. \n\n\nDetails:\n\n- single card + envelope + sticker for sealing\n- blank inside\n- 2.5" x 3.5"\n- Printed on 120lb superfine paper\n- Original watercolor artwork by Emily Lex\n',
  tags: [],
  msrpDollars: 4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:14:48.522Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
